import { getLocale } from "../runtime";

const da_allbrandsdescription = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Udforsk alle mærker tilgængelige hos Glimja`
};

const en_allbrandsdescription = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Explore all brands available at Glimja`
};

const es_allbrandsdescription = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Explora todas las marcas disponibles en Glimja`
};

const fi_allbrandsdescription = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Tutustu kaikkiin Glimjan merkkeihin`
};

const nb_allbrandsdescription = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Utforsk alle merkevarer som finnes på Glimja`
};

const sv_allbrandsdescription = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Utforska alla varumärken som finns tillgängliga på Glimja`
};

const allbrandsdescription = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "da") return da_allbrandsdescription(inputs)
	if (locale === "en") return en_allbrandsdescription(inputs)
	if (locale === "es") return es_allbrandsdescription(inputs)
	if (locale === "fi") return fi_allbrandsdescription(inputs)
	if (locale === "nb") return nb_allbrandsdescription(inputs)
	if (locale === "sv") return sv_allbrandsdescription(inputs)
	return "allBrandsDescription";
};

export { allbrandsdescription as "allBrandsDescription" };